<div class="container-fluid res-sales-dashboard-page">
  <p-toast [style]="{marginTop: '80px'}"></p-toast>
  @if (formLoading) {
    <div class="progress-spinner">
      <app-spinner [formLoading]="formLoading"></app-spinner>
    </div>
  }

  <h2>Res Sales Dashboard</h2>

  @if (showSearchUI) {
    <app-search-template searchLabel="Search" [showSearchButton]=true [reset]=true [showLocations]=true [showDevelopments]=true
      [showShortTermRentals]=true [showRateBuckets]=false [showBedrooms]=true [showSeasons]=false
      [showReservationStatuses]=false [showStartDate]=true [showEndDate]=true [showSaleDateStart]=true
      [showFilterDateStart]=true [showFilterDateEnd]=true
      [showSaleDateEnd]=true [defaultStartDate]="defaultStartDate" [showSaleYear]=false [displayRecordsOnPageLoad]="true"
      [defaultEndDate]="defaultEndDate" [defaultShortTermRentalIds]="defaultShortTermRentalIds"
      [showBlankStartAndEndDate]=true [showReferralSources]=true [showResTypes]=true
      [startDateLabel]="'Check-In Date'" [endDateLabel]="'Check-Out Date'"
      [defaultReservationStatuses]="defaultReservationStatuses" (doSearchCB)="onSearchSubmit($event)">
    </app-search-template>
  }
  <br><br>

  <app-sales-report-statistics [revenueTtl]="revenueTtl" [revenuePNTAvg]="revenuePNTAvg" [resRevTotal]="resRevTotal" [resRevMaster]="resRevMaster"></app-sales-report-statistics>

  <br><br>

  <app-sales-by-property [resRevByDay]="resRevByDay" [resRevMaster]="guestReservations" [groupDefaultExpanded]="groupDefaultExpanded"></app-sales-by-property>
  <app-cancels-by-property [resRevByDay]="resRevByDay" [resRevMaster]="cancelledReservations" [groupDefaultExpanded]="groupDefaultExpanded"></app-cancels-by-property>
  <app-holds-by-property  [resRevByDay]="resRevByDay" [resRevMaster]="holdReservations" [groupDefaultExpanded]="groupDefaultExpanded"></app-holds-by-property>
  <app-holds-expire-by-property [resRevByDay]="resRevByDay" [resRevMaster]="expiredReservations" [groupDefaultExpanded]="groupDefaultExpanded"></app-holds-expire-by-property>
  @if (resRevByDayLoading) {
    <div class="text-center py-4">
      <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
      <p class="mt-2">Loading occupancy &amp; channel data...</p>
    </div>
  }
  @if (!resRevByDayLoading) {
    <app-res-sales-summary [resRevByDay]="resRevByDay" [groupDefaultExpanded]="2"></app-res-sales-summary>
    <app-res-sales-agent [resRevByDay]="resRevByDay" [groupDefaultExpanded]="groupDefaultExpanded"></app-res-sales-agent>
    <app-res-sales-development [resRevByDay]="resRevByDay" [groupDefaultExpanded]="groupDefaultExpanded"></app-res-sales-development>
    <app-sales-by-channel [resRevByDay]="resRevByDay" [groupDefaultExpanded]="groupDefaultExpanded"></app-sales-by-channel>
    <app-sales-by-location [resRevByDay]="resRevByDay" [groupDefaultExpanded]="groupDefaultExpanded"></app-sales-by-location>
    <app-res-sales-onhold [holdReservations]="holdReservations" [holdReservationsCount]="holdReservationsCount" [groupDefaultExpanded]="groupDefaultExpanded"></app-res-sales-onhold>
  }

  @if (upsellLoading) {
    <div class="text-center py-4">
      <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
      <p class="mt-2">Loading upsell pipeline...</p>
    </div>
  }
  <app-upsell-dashboard [upsellOffers]="upsellOffers"></app-upsell-dashboard>

  <br><br>
</div>